import React, { useState } from 'react';


import {
    getLogin, GetProfile, SetResetPassword, SetChangePassword, SetPassword, setLogout
} from '../utils/api-action';
const login = async (param) => {

    let data = [];

    var result = await getLogin(param)


    const { status, content, description } = result;
    if (status === 200) {

    } else if (status === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}

const logout = async (param) => {

    let data = [];

    var result = await setLogout(param)


    const { status, content, description } = result;
    if (status === 200) {

    } else if (status === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}

const getProfile = async (param) => {

    let data = [];

    var result = await GetProfile(param)
    const { status, content, description } = result;
    if (status === 200) {


    } else if (status === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}
const resetPassword = async (param) => {

    let data = [];

    var result = await SetResetPassword(param)
    const { status, content, description } = result;
    if (status === 200) {


    } else if (status === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}


const changePassword = async (param) => {



    var result = await SetChangePassword(param)
    const { status, content, description } = result;
    if (status === 200) {


    } else if (status === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}

const updatePassword = async (param) => {



    var result = await SetPassword(param)
    const { status, content, description } = result;
    if (status === 200) {


    } else if (status === 401) {
        localStorage.clear();
    }
    else {

    }

    return result;

}



export {
    login,
    getProfile,
    resetPassword,
    changePassword,
    updatePassword,
    logout

};
